var _defs, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFalkonTextLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 446 188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1450ff;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.21,
    y1: 87.88,
    x2: 19.2,
    y2: 87.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ffad00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ff9400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ff8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 70.28,
    y1: 80.9,
    x2: 106.13,
    y2: 80.9,
    xlinkHref: "#linear-gradient"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.9,
    y: 64.2,
    width: 19.4,
    height: 7.28,
    rx: 3.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.9,
    y: 104.6,
    width: 19.4,
    height: 7.28,
    rx: 3.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -0.2,
    y: 84.2,
    width: 19.4,
    height: 7.28,
    rx: 3.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.2,110.4V76.8h20.2v3.6H137.3V91.8h14.6v3.6H137.3v15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.1,110.4h-4.2l12.3-33.6h4.2l12.4,33.6h-4.3l-10-28.3h-.3Zm1.6-13.1h17.2v3.6H163.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M196.6,110.4V76.8h4.1v30h15.6v3.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M227.2,110.4V76.8h4.1V93.5h.4l15.1-16.7h5.3L238,92l14.1,18.4h-4.9L235.5,94.8l-4.2,4.7v10.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M288.8,93.6a20.1,20.1,0,0,1-2,9.2,13.9,13.9,0,0,1-5.2,6,14.4,14.4,0,0,1-7.7,2.1,14,14,0,0,1-7.6-2.1,14.8,14.8,0,0,1-5.3-6,20.2,20.2,0,0,1-1.9-9.2,20.4,20.4,0,0,1,1.9-9.2,15.2,15.2,0,0,1,5.3-5.9,14,14,0,0,1,7.6-2.1,13.8,13.8,0,0,1,12.9,8A20.4,20.4,0,0,1,288.8,93.6Zm-4,0a17.6,17.6,0,0,0-1.4-7.3,11.2,11.2,0,0,0-3.9-4.6,11,11,0,0,0-11.1,0,11.2,11.2,0,0,0-3.9,4.6,16.1,16.1,0,0,0-1.5,7.3,16.5,16.5,0,0,0,1.5,7.4,10.9,10.9,0,0,0,3.9,4.5,10.4,10.4,0,0,0,11.1,0,10.9,10.9,0,0,0,3.9-4.5A18.1,18.1,0,0,0,284.8,93.6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M326.9,76.8v33.6h-4L304.6,84h-.3v26.4h-4.1V76.8h4l18.3,26.5h.4V76.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M358.3,86.5a4,4,0,0,0-1.6-3.1,7.1,7.1,0,0,0-4.1-1.1,7.9,7.9,0,0,0-2.9.5,5.3,5.3,0,0,0-1.9,1.3,3.4,3.4,0,0,0-.6,2,2.4,2.4,0,0,0,.4,1.5,4.3,4.3,0,0,0,1.1,1.2,7.5,7.5,0,0,0,1.8.8,6.6,6.6,0,0,0,2,.6l3,.8a16.4,16.4,0,0,1,4.1,1.3,11.6,11.6,0,0,1,3.2,2,8.3,8.3,0,0,1,2.1,2.8,8.7,8.7,0,0,1,.7,3.7,8.9,8.9,0,0,1-1.6,5.4,10.4,10.4,0,0,1-4.4,3.5,18.6,18.6,0,0,1-7,1.2,19.2,19.2,0,0,1-7.1-1.2,11,11,0,0,1-4.7-3.7,11.8,11.8,0,0,1-1.8-6.1h6.9a5.3,5.3,0,0,0,1,2.8,5.8,5.8,0,0,0,2.3,1.7,8.8,8.8,0,0,0,3.3.6,7.5,7.5,0,0,0,3.1-.6,4.6,4.6,0,0,0,2.1-1.4,3.6,3.6,0,0,0,.7-2.2,3.1,3.1,0,0,0-.6-1.9,6.3,6.3,0,0,0-2-1.3,14.1,14.1,0,0,0-3.1-1l-3.6-.9a15.5,15.5,0,0,1-6.7-3.2,7.6,7.6,0,0,1-2.5-6,8.8,8.8,0,0,1,1.7-5.3,11.6,11.6,0,0,1,4.5-3.6,18.5,18.5,0,0,1,13.1,0,10.3,10.3,0,0,1,4.3,3.6,9.5,9.5,0,0,1,1.7,5.3Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.8,76.8h8.8l9.3,22.6h.3l9.3-22.6h8.8v33.6h-6.9V88.6h-.3l-8.7,21.7h-4.7L378,88.5h-.3v21.9h-6.9Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M431.8,86.5a4.1,4.1,0,0,0-1.7-3.1,6.8,6.8,0,0,0-4-1.1,8.5,8.5,0,0,0-3,.5,4.2,4.2,0,0,0-1.8,1.3,3.4,3.4,0,0,0-.6,2,2.4,2.4,0,0,0,.3,1.5,3.4,3.4,0,0,0,1.2,1.2l1.7.8a6.5,6.5,0,0,0,2.1.6l3,.8a15.7,15.7,0,0,1,4,1.3,10.3,10.3,0,0,1,3.2,2,8.3,8.3,0,0,1,2.1,2.8,8.7,8.7,0,0,1,.8,3.7,9.6,9.6,0,0,1-1.6,5.4,10.1,10.1,0,0,1-4.5,3.5,17.9,17.9,0,0,1-7,1.2,19.2,19.2,0,0,1-7.1-1.2,11.6,11.6,0,0,1-4.7-3.7,10.9,10.9,0,0,1-1.7-6.1h6.9a5.2,5.2,0,0,0,.9,2.8,6.6,6.6,0,0,0,2.3,1.7,8.8,8.8,0,0,0,3.3.6,7.9,7.9,0,0,0,3.2-.6,4.6,4.6,0,0,0,2.1-1.4,4.4,4.4,0,0,0,.7-2.2,2.6,2.6,0,0,0-.7-1.9,5.7,5.7,0,0,0-1.9-1.3,18.9,18.9,0,0,0-3.1-1l-3.7-.9a16.7,16.7,0,0,1-6.7-3.2,7.8,7.8,0,0,1-2.4-6,8.8,8.8,0,0,1,1.6-5.3,11.6,11.6,0,0,1,4.5-3.6,17.6,17.6,0,0,1,6.6-1.2,16,16,0,0,1,6.5,1.2,10.6,10.6,0,0,1,4.4,3.6,9.5,9.5,0,0,1,1.6,5.3Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.2,69.6c-9.3-2.5-15,2.1-23.9,4L85.9,89.2A7,7,0,0,1,88,92.9l.3-.9c6.3-17.9,17.8-12.2,17.8-12.2S103.8,72.1,94.2,69.6Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.5,58.4,87,88.4a6.1,6.1,0,0,1,.2,8.7l-32,33.7a1.3,1.3,0,0,1-2.3-.9l-.3-14.3-27-25.7a6.3,6.3,0,0,1-.3-8.8L46.7,58.7A6.3,6.3,0,0,1,55.5,58.4Zm6.9,42.3a4.4,4.4,0,0,0,6.1-.2,4.3,4.3,0,1,0-6.1.2Zm-9.3-8.8a4.4,4.4,0,0,0,6.1-.2,4.3,4.3,0,0,0-.2-6,4.2,4.2,0,0,0-6,.1A4.4,4.4,0,0,0,53.1,91.9ZM43.9,83a4.2,4.2,0,0,0,6-.1,4.3,4.3,0,1,0-6,.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalkonTextLogoMobile);
export default __webpack_public_path__ + "static/media/falkon-text-logo-mobile.1bf8bf1448483fd15f5c75b184aca024.svg";
export { ForwardRef as ReactComponent };